/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormState, FormStateBuilder, getRouteInitData, TextDictionary } from '@gh/common-shared';
import { REGION_CODE } from '@gh/config';
import { assign } from 'lodash';
import { SystemVarsMasterZoneDetails } from '../../resources/model/system-vars-master-zone-details.model';

@Component({
  selector: 'gh-system-vars-master-zone-tab',
  template: require('./system-vars-master-zone-tab.component.html'),
  styles: [require('./system-vars-master-zone-tab.component.scss')],
})
export class SystemVarsMasterZoneTabComponent implements OnInit {
  states: TextDictionary;
  form: FormState<SystemVarsMasterZoneDetails>;

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder) {
  }

  /**
   * Init component
   */
  ngOnInit(): void {
    const { masterZone, ...init } = getRouteInitData(this.route);
    assign(this, init);

    this.form = this.formStateBuilder.buildPlain({
      value: masterZone,
      children: {
        id: void 0,
        name: void 0,
        code: void 0,
        companyName: void 0,
        businessType: void 0,
        formedDate: void 0,
        taxId: void 0,
        acn: void 0,
        tradingAs: void 0,
        street1: void 0,
        street2: void 0,
        city: void 0,
        state: void 0,
        postcode: void 0,
        phone1: void 0,
        phone2: void 0,
        fax: void 0,
        abn: void 0,
        gst: void 0,
        active: void 0,
        etag: void 0,
      },
    });
  }

  checkRegion(regionCode: string): boolean {
    return regionCode === REGION_CODE;
  }

}
